import { useEffect, useMemo, useState } from "react";
import { getTokenRefresh } from "../../../helpers/token/refreshToken";
import { connectAdminDriversSocket } from "../data/adminDriversSocket";

export function useAdminDriverTracking(retryCount) {
  const [driversById, setDriversById] = useState({});
  const [connectionStatus, setConnectionStatus] = useState("connecting");
  const [connectionError, setConnectionError] = useState("");

  const drivers = useMemo(
    () => Object.values(driversById).sort((a, b) => a.driverId - b.driverId),
    [driversById],
  );

  useEffect(() => {
    let disconnect;
    try {
      const token = getTokenRefresh();
      if (!token || typeof token !== "string") {
        setConnectionStatus("error");
        setConnectionError(
          "No se encontró una sesión válida de administrador.",
        );
        return undefined;
      }

      setConnectionError("");
      disconnect = connectAdminDriversSocket({
        token,
        onStatus: setConnectionStatus,
        onError: setConnectionError,
        onEvent: (event) => {
          console.log("[useAdminDriverTracking] Evento recibido:", event);
          const data = event.payload?.data;
          if (event.type === "snapshot" && Array.isArray(data)) {
            setDriversById(
              Object.fromEntries(
                data
                  .filter(
                    (driver) =>
                      Number.isSafeInteger(driver.driverId) &&
                      driver.driverId > 0,
                  )
                  .map((driver) => [driver.driverId, driver]),
              ),
            );
            setConnectionError("");
            return;
          }

          if (
            event.type === "upsert" &&
            data &&
            Number.isSafeInteger(data.driverId) &&
            data.driverId > 0
          ) {
            setDriversById((current) => ({
              ...current,
              [data.driverId]: data,
            }));
            setConnectionError("");
            return;
          }

          if (event.type === "remove" && Number.isSafeInteger(data?.driverId)) {
            setDriversById((current) => {
              const next = { ...current };
              delete next[data.driverId];
              return next;
            });
          }
        },
      });
    } catch (error) {
      setConnectionStatus("error");
      setConnectionError(
        error.message || "No se pudo iniciar el seguimiento de conductores.",
      );
    }

    return () => disconnect?.();
  }, [retryCount]);

  return { drivers, connectionStatus, connectionError };
}
